import React, { PropTypes } from 'react';
import { withRouter } from 'react-router';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BatchActionsListContainer from '../../../../containers/shared/BatchActions/BatchActionsListContainer';
import ItemList from '../../../shared/ItemList';
import Pagination from '@bibliocommons/pagination';
import RecentlyReturnedItem from '../RecentlyReturnedItem';
import BatchActionsListItem from '../../../shared/BatchActions/BatchActionsListItem';
import Immutable from 'immutable';
import './RecentlyReturnedHistoryView.scss';
import renderAddToShelfBatchActions from '../../shared/AddToShelfBatchActions';


const historyItemToActionItem = (item) => Immutable.Map({
  id: item.get('id'),
  metadataId: item.get('metadataId'),
  actions: item.get('actions', Immutable.List())
});

class RecentlyReturnedHistoryView extends BcReactComponent {

  constructor(props) {
    super(props);
    this.bindAll('renderBatchActionsMenu', 'handleBatchAdd');
  }

  renderBibListItem(item, selectedItems, updateItem) {
    if (!item.get('metadataId')) {
      return null;
    }

    const actionItem = historyItemToActionItem(item);

    return (
      <BatchActionsListItem
        actionItem={actionItem}
        selectedItems={selectedItems}
        updateItem={updateItem}>
        <RecentlyReturnedItem
          item={item}
          defaultSort={this.props.defaultSort}
          rating={this.props.ratings.get(item.get('metadataId'))}
          ratingsTransactions={this.props.ratingsTransactions}
          ratingsActions={this.props.ratingsActions} />
      </BatchActionsListItem>
    );
  }

  renderBatchActionsMenu(selectedActionItems) {
    const itemsprefilter = selectedActionItems
      .filter((selectedItem) => Immutable.List.isList(selectedItem.get('actions')));

    return [
      ...renderAddToShelfBatchActions({
        items: itemsprefilter,
        handleBatchAddToShelf: this.handleBatchAdd
      })
    ];
  }

  handleBatchAdd(selectedActionItems, shelfName) {
    const metadataIds = selectedActionItems.map(item => item.get('metadataId'))
      .toSet()
      .toList();
    this.props.shelfActions.batchAddToShelf({ metadataIds, shelfName });
  }

  render() {
    const actionList = this.props.items.map(historyItemToActionItem);

    return (
      <div className="cp-borrowing-history-list">
        <BatchActionsListContainer
          list={actionList}
          totalItems={this.props.totalCount}
          renderActionsMenu={this.renderBatchActionsMenu}>
          {(selectedItems, updateItem) => (
            <ItemList>
              {this.props.items.map(item => this.renderBibListItem(item, selectedItems, updateItem))}
            </ItemList>
          )}
        </BatchActionsListContainer>
        <div className="borrowing-history-paging">
          <Pagination
            isFetching={this.props.isFetching}
            page={(this.props.recentlyReturnedPaging.get('page'))}
            limit={this.props.recentlyReturnedPaging.get('limit')}
            count={this.props.recentlyReturnedPaging.get('count')}
            pages={this.props.recentlyReturnedPaging.get('pages')}
            className="recently-returned-paging clearfix"
            showPages />
        </div>
      </div>
    );
  }
}

RecentlyReturnedHistoryView.propTypes = {
  items: ImmutablePropTypes.list,
  totalCount: PropTypes.number,
  recentlyReturnedPaging: ImmutablePropTypes.map,
  renderBatchActionButtons: PropTypes.func,
  isFetching: React.PropTypes.bool,
  shelfActions: PropTypes.objectOf(PropTypes.func),
  defaultSort: PropTypes.string,
  RecentlyReturnedActions: PropTypes.objectOf(PropTypes.func),
  ratingsTransactions:  ImmutablePropTypes.map,
  ratings: ImmutablePropTypes.map,
  ratingsActions:  PropTypes.objectOf(PropTypes.func)
};

export default withRouter(RecentlyReturnedHistoryView);



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedHistoryView/RecentlyReturnedHistoryView.jsx